import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9bd4cb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Past Cards", -1))
const _hoisted_2 = {
  key: 1,
  class: "message"
}

import { computed } from 'vue';
import { Faction } from '@/typings/faction';
import FactionEntry from '@/components/Faction/FactionEntry.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    factions: null
  },
  setup(__props: any) {

const props = __props as {
  factions: Faction[];
}



const sortedFactions = computed(() => {
  const factions = [...props.factions];
  factions.sort((a, b) => (b.EntryEnds ?? '').localeCompare(a.EntryEnds ?? ''));
  return factions;
});

const activeFactions = computed(() => {
  return sortedFactions.value.filter((faction) => !faction.ClosedAt);
});

const pastFactions = computed(() => {
  return sortedFactions.value.filter((faction) => faction.ClosedAt);
});

return (_ctx: any,_cache: any) => {
  return (__props.factions.length > 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeFactions), (faction) => {
            return (_openBlock(), _createBlock(FactionEntry, {
              key: faction.Uuid,
              faction: faction
            }, null, 8, ["faction"]))
          }), 128))
        ]),
        _hoisted_1,
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pastFactions), (faction) => {
            return (_openBlock(), _createBlock(FactionEntry, {
              key: faction.Uuid,
              faction: faction
            }, null, 8, ["faction"]))
          }), 128))
        ])
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, " Looks like you haven't played in any Time-Limited Factions yet! "))
}
}

})